import type { TagPassThroughMethodOptions } from 'primevue/tag'

export default {
  icon: (options: TagPassThroughMethodOptions) => ({
    class: [
      {
        '!body-1-regular': options.attrs.size === 'large',
        '!body-2-regular':
          !options.attrs.size ||
          options.attrs.size === 'medium' ||
          options.attrs.size === 'small',
        '!body-3-regular': options.attrs.size === 'x-small',
      },
    ],
  }),
  root: (options: TagPassThroughMethodOptions) => ({
    class: [
      {
        '!body-1-regular': options.attrs.size === 'large',
        '!body-2-regular':
          !options.attrs.size ||
          options.attrs.size === 'medium' ||
          options.attrs.size === 'small',
        '!body-3-regular': options.attrs.size === 'x-small',
      },
    ],
  }),
}
